export default {
    menu : {
      home:"home"
    },
    content:{
      main:"this is content"
    },
    tableIndex:{
      "EmployeeID": "Employee ID",
      "Name": "Name",
      "DeliveryLocation": "Delivery Location",
      "XiamenHQ": "Xiamen HQ",
      "JinjiangHQ": "Jinjiang HQ",
      "ShanghaiHQ": "Shanghai HQ",
      "HongKongHQ": "Hong Kong HQ",
      "OtherRegions": "Other regions",
      "Singapore": "Singapore",
      "Malaysia": "Malaysia",
      "Thailand": "Thailand",
      "Indonesia": "Indonesia",
      "Philippines": "Philippines",
      "Vietnam": "Vietnam",
      "DocumentNumber": "Document Number",
      "AddDocumentNumber": "Add document number",
      "PagesOfSupportingDocuments": "Pages of Supporting Documents",
      "Page": "Page",
      "PleaseScanTheQRCodeOrEnterTheDocumentNumber": "Please Scan the QR Code or Enter the Document Number",
      "Submit": "Submit",
      "CurrentLocation": "Current Location",
      "PleaseNoteToAvoidScanningErrorsPleaseEnsureThatTheCameraIsClearWhenScanningTheDocuments": "Please note: To avoid scanning errors, please ensure that the camera is clear when scanning the documents.",
      "DocumentNumber1": "Document Number",
      "City": "City",
      "CreationTime": "Creation Time",
      "Scanned": "Scanned",
      "Delivered": "Delivered",
      "NotMailed": "Not Mailed",
      "VerificationException": "Verification Exception",
      "DocumentRemarks": "Document Remarks",
      "Search": "Search",
      "PleaseEnterDocumentNumberToSearch": "Please Enter Document Number to Search",
      "SurveySystem": "Survey System",
      "FinanceScanning": "Finance Scanning",
      "FinancialDocument": "Financial Document",
      "SurveyManagement": "Survey Management",
      "ActivityManagement": "Activity Management",
      "DocumentDate": "Document Date",
      "DeliveryLocation": "Delivery Location",
      "AffiliatedBrand": "Affiliated Brand",
      "LocationName": "Location Name",
      "CourierTrackingNumber": "Courier Tracking Number",
      "CenterName": "Center Name",
      "CourierServiceAvailable": "Courier Service Available (Yes/No)",
      "EmployeeID": "Employee ID",
      "Submitter": "Submitter",
      "ContactNumber": "Contact Number",
      "Operator": "Operator",
      "DeliveryReceived": "Delivery Received (Yes/No)",
      "Receiver": "Receiver",
      "DocumentStatus": "Document Status",
      "ReceivingTime": "Receiving Time",
      "ScanningTime": "Scanning Time",
      "Search1": "Search",
      "Reset": "Reset",
      "CloseAdvancedSearch": "Close Advanced Search",
      "Close": "Close",
      "AdvancedSearch": "Advanced Search",
      "Export": "Export",
      "ImportModifiedData": "Import Modified Data",
      "ImportNewData": "Import New Data",
      "No": "No.",
      "Dispatcher": "Dispatcher",
      "SubmissionTime": "Submission Time",
      "WhetherThereIsACourierTrackingNumber": "Whether There Is a Courier Tracking Number",
      "DocumentNumber": "Document Number",
      "PagesOfSupportingDocuments": "Pages of Supporting Documents",
      "Remarks": "Remarks",
      "ContactPersonForOtherRegions": "Contact Person for other regions",
      "TrackingNumber": "Tracking Number",
      "Operator1": "Operator",
      "OperationTime": "Operation Time",
      "CourierReceived": "Courier Received (Yes/No)",
      "ScanningTime1": "Scanning Time",
      "ScanningPerson": "Scanning Person",
      "TimeOfUploadVerification": "Time of Upload Verification",
      "StatusOfPaperDocumentFlow": "Status of Paper Document Flow",
      "Remarks1": "Remarks",
      "SubmissionToMailingTimeliness": "Submission to Mailing Timeliness",
      "MailingToScanningTimeliness": "Mailing to Scanning Timeliness",
      "startDate": "start date",
      "endDate": "end date",
      "have": "yes",
      "nohave": "no",
      "importTitle": "Import Document data",
      "importcontent1":"Drag the file here, or",
      "importcontent2":"Click to upload",
      "importcontent3":"Overwrite existing user data",
      "importTips":"Tip: Only xls or xlsx files can be imported",
      "confirmBtn":"confirm",
      "cancelBtn":"cancel",
      "downloadExcel":"Download Excel templates"

    }
}